<div class="-contact-head" *ngIf="title">
  <icon icon="information" class="-sm15"></icon><h3>{{ title }}</h3>
</div>
<p *ngIf="description">{{ description }}</p>
<div class="-links" *ngIf="links.length > 0">
  <app-link *ngFor="let item of links" [to]="item.path">{{item.title}}</app-link>
</div>